import React, { useEffect, useState } from "react";
import ContactMenu from "../../components/contact/ContactMenu";
import StaffCard from "../../components/card/StaffCard";
import PageBanner from "../../components/PageBanner";
import AboutUsService from "../../services/aboutUs";
import BannerService from "../../services/banner";
import { useParams } from "react-router-dom";

export default function Staff() {
  let [staffData, setStaffData] = useState([]);
  let [doctorData, setDoctorData] = useState([]);

  let [showStaff, setStaffMenu] = useState(true);
  let [showDoctor, setDoctorMenu] = useState(true);

  let [staffBanner, setStaffBanner] = useState([]);

  let { lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getStaffData();
    getDoctorData();
    getStaffBanner();
  }, []);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`${process.env.REACT_APP_WEB_URL}/th`, "_self");
    }
  });

  const getStaffData = async () => {
    try {
      let res = await AboutUsService.getStaff();
      setStaffData(res);
    } catch {
      console.error();
    }
  };

  const getDoctorData = async () => {
    try {
      let res = await AboutUsService.getDoctor();
      setDoctorData(res);
    } catch {
      console.error();
    }
  };

  const getStaffBanner = async () => {
    try {
      let res = await BannerService.getBanner(5);
      setStaffBanner(res);
    } catch {
      console.error();
    }
  };

  const bannerText = [{ name: "Doctors and Staffs", href: "/staff" }];

  return (
    <div id="staff" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"บุคลากร"}
        text_en={"Doctors and Staffs"}
        banner={staffBanner.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* ติดต่อเรา */}
          <div className="mt-[35px] mb-[300px]">
            <ContactMenu isOpen={2} lang={lang} />

            <div className="flex flex-row divide-x divide-darkGray gap-[64px] justify-center mt-[45px]">
              <h1
                className={
                  `text-[22px] md:text-[28px] cursor-pointer ` +
                  (!showStaff && "text-lightGray")
                }
                onClick={() => setStaffMenu(!showStaff)}
              >
                {lang === "th" ? "เจ้าหน้าที่" : "Staff"}
              </h1>
              <h1
                className={
                  `text-[22px] md:text-[28px] pl-[64px] cursor-pointer ` +
                  (!showDoctor && "text-lightGray")
                }
                onClick={() => setDoctorMenu(!showDoctor)}
              >
                {lang === "th" ? "แพทย์" : "Doctor"}
              </h1>
            </div>

            <div id="staff-info" className="text-left mt-[44px]">
              {showStaff && (
                <div>
                  <h1 className="text-[28px] xl:text-[32px] cursor-pointer">
                    {lang === "th" ? "เจ้าหน้าที่" : "Staff"}
                  </h1>
                  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[24px] mt-[25px]">
                    {staffData.list &&
                      staffData.list.map((item, i) => (
                        <div key={i}>
                          <StaffCard data={item} is_staff={true} lang={lang} />
                        </div>
                      ))}
                  </div>
                </div>
              )}

              {showDoctor && (
                <div>
                  <h1 className="mt-[73px] text-[28px] xl:text-[32px] cursor-pointer">
                    {lang === "th" ? "แพทย์" : "Doctor"}
                  </h1>
                  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[24px] mt-[25px]">
                    {doctorData.list &&
                      doctorData.list.map((item, i) => (
                        <div key={i}>
                          <StaffCard data={item} lang={lang} />
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
